import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export async function emailRoi(payload) {
  const res = await axios.post(`${API}/roi-lead`, payload);
  return res.data;
}
